import { useQuery } from '@tanstack/react-query';
import service from '../service';
import { useAuth } from '../contexts/auth';

export type InboxUnreadSummary = {
  total: number;
  perInbox: { inboxId: string; unreadCount: number }[];
};

/**
 * Polls the signed-in user's own assigned-inbox unread inbound-SMS count for the
 * topbar/title notification indicator. Keeps polling while the tab is hidden so
 * the title badge updates without the user returning to the tab.
 */
export function useUnreadMessages() {
  const { user } = useAuth();
  const userId = user?.id;

  return useQuery<InboxUnreadSummary>({
    queryKey: ['inbox-unread', userId],
    queryFn: () => service.getUserInboxUnread(userId as string),
    enabled: !!userId,
    refetchInterval: 15000,
    refetchIntervalInBackground: true,
  });
}
